var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnycoinLogoOriginal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1116.1018 281.1642",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Components"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_28b212f0-e8bd-4166-9096-d525cbffd3f6_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m140.582,0C63.262,0,0,63.2618,0,140.5822s63.262,140.582,140.582,140.582,140.582-63.262,140.582-140.582S217.9021,0,140.582,0Zm0,259.5361c-65.4248,0-118.9541-53.5294-118.9541-118.954S75.1572,21.6281,140.582,21.6281s118.9541,53.5293,118.9541,118.9541-53.5293,118.954-118.9541,118.954Z",
    style: {
      fill: "#54bad1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.9785,105.9655l-3.8752,23.879c6.7515,1.0948,27.7019,6.1122,29.8979-7.3979,2.2849-14.0923-19.2715-15.3864-26.0227-16.4811Z",
    style: {
      fill: "#54bad1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.1484,141.8964l-4.2751,26.3284c8.1067,1.3075,33.2603,7.1223,35.6631-7.7291h0c2.5142-15.4891-23.2805-17.2819-31.3879-18.5992Z",
    style: {
      fill: "#54bad1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.582,41.3837c-54.7854,0-99.1982,44.4126-99.1982,99.1985s44.4128,99.1984,99.1982,99.1984,99.1985-44.413,99.1985-99.1984-44.4128-99.1985-99.1985-99.1985Zm46.2036,125.301c-4.811,18.598-19.7056,21.3801-39.9993,19.2715l-3.2224,19.8359-11.9597-1.9392,3.1807-19.5703c-3.0996-.5-6.2698-1.0411-9.5391-1.6411l-3.1897,19.6617-11.9465-1.9403,3.219-19.8727c-2.7947-.4718-5.6365-.9832-8.5322-1.4567l-15.564-2.5247,4.6938-13.8973s8.8245,1.5732,8.6934,1.413c3.3855.5431,4.676-1.7422,5.136-3.2324l8.7344-53.8248c-.0647-2.5012-1.1851-5.5693-6.0291-6.3568.1731-.1389-8.686-1.4034-8.686-1.4034l2.0693-12.7738,16.4946,2.6821-.0083.0612c2.4795.4006,5.0303.7651,7.6282,1.1324l3.1914-19.6418,11.9531,1.9398-3.1262,19.2567c3.2031.4543,6.4272.9136,9.5713,1.4233l3.103-19.1304,11.96,1.9392-3.1875,19.6482c15.2183,3.8574,26.6753,10.5898,25.739,24.9758h-.0002c-.668,10.5295-6.0125,16.0472-13.5193,18.453,10.969,4.5927,17.0203,12.5371,13.1423,27.5118Z",
    style: {
      fill: "#54bad1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400.8031,154.2867l-14.7065-42.149-14.7077,42.149h29.4142Zm-25.3874-71.4539h23.1154l42.9429,115.0277h-24.4298l-9.2287-24.3476h-43.5737l-9.0937,24.3476h-22.6765l42.9441-115.0277Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.651 82.8328 485.6159 82.8328 538.0899 159.3806 538.0899 82.8328 561.1506 82.8328 561.1506 197.8605 539.1854 197.8605 486.7114 121.312 486.7114 197.8605 463.651 197.8605 463.651 82.8328",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "626.8189 153.7116 583.053 82.8328 610.112 82.8328 638.7602 130.2405 665.6546 82.8328 690.4129 82.8328 649.9343 153.7116 649.9343 197.8605 626.8189 197.8605 626.8189 153.7116",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m701.0886,141.1684v-3.2865c0-39.9584,22.8414-56.9662,51.215-56.9662,25.6345,0,45.9843,12.2147,47.9278,39.1644h-24.1006c-2.574-13.4472-11.366-19.6101-23.8272-19.6101-13.94,0-27.1132,9.2848-27.1132,37.4119v3.2865c0,29.6333,14.1316,39.0541,27.1132,39.0541,13.2562,0,21.9922-7.0112,23.8272-19.6089h24.1006c-2.3552,28.3461-22.0188,39.164-47.9278,39.164-29.3317,0-51.215-16.7611-51.215-58.6092Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m905.3932,141.1684v-3.2865c0-27.4971-14.1321-37.4119-29.5776-37.4119s-29.5788,9.9148-29.5788,37.4119v3.2865c0,29.3042,14.1321,39.0541,29.5788,39.0541s29.5776-9.7498,29.5776-39.0541Zm-83.2579,0v-3.2865c0-39.9858,25.3334-56.9662,53.6803-56.9662s53.6793,16.9804,53.6793,56.9662v3.2865c0,41.7655-25.3337,58.6092-53.6793,58.6092s-53.6803-16.8437-53.6803-58.6092Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 959.8875,
    y: 82.8328,
    width: 23.1152,
    height: 115.0277,
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1018.6022 82.8328 1040.5674 82.8328 1093.0413 159.3806 1093.0413 82.8328 1116.1018 82.8328 1116.1018 197.8605 1094.1368 197.8605 1041.6629 121.312 1041.6629 197.8605 1018.6022 197.8605 1018.6022 82.8328",
    style: {
      fill: "currentColor"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnycoinLogoOriginal);
export default __webpack_public_path__ + "static/media/anycoin-logo-original.76e0b5d1e0e98ad835cba5d7f0a098b0.svg";
export { ForwardRef as ReactComponent };